import React from "react";
import { IllustrationCardType } from "../types/IllustrationCard";
import { CtaButton } from "../Cta/cta-button";

const IllustrationCard: React.FC<IllustrationCardType> = ({
  dropdown,
  headline,
  illustration,
  illustrationAltText,
  link,
  subCopy,
  onClick,
  triggerAnalytics,
}) => {
  const ctaProps = {
    copy: link?.ctaCopy,
    isDisabled: false,
    link: link?.ctaLink?.value?.data?.url || null,
    linkUrl: link?.ctaUrl,
  };

  const currentLink = link?.ctaLink?.value?.data?.url || link?.ctaUrl;

  return (
    <a
      onClick={onClick}
      className="cursor-pointer h-full illustration--card-container"
      href={currentLink}
    >
      <div className="bg-mint-500 px-6 pt-6 pb-8 rounded-3xl hover:bg-mint-300 illustration--card h-full">
        {dropdown === "long" ? (
          <div className="flex items-center gap-6 sm:flex-col sm:items-start">
            <img
              src={illustration}
              alt={illustrationAltText}
              className="max-w-[118px] max-h-[125px] sm:w-[100px] sm:h-[100px] sm:object-cover"
            />
            <div>
              <h5 className="illustration-card__font-set body--text-extra-large pb-4">
                {headline}
              </h5>
              <p className="illustration-card__font-set body--text-regular pb-6">
                {subCopy}
              </p>
              <div className="flex">
                {link?.ctaCopy && (
                  <CtaButton
                    {...ctaProps}
                    copySize="bodyRegular"
                    variant="tertiaryForest"
                    onClick={triggerAnalytics}
                  />
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-col h-full">
            <div className="flex items-center gap-2 pb-4 sm:flex-col sm:items-start sm:gap-6">
              <img
                src={illustration}
                alt={illustrationAltText}
                className="w-9 h-9 sm:w-[100px] sm:h-[100px]"
              />
              <h5 className="illustration-card__font-set body--text-extra-large">
                {headline}
              </h5>
            </div>
            <p className="illustration-card__font-set body--text-regular pb-6 flex-grow">
              {subCopy}
            </p>
            <div className="flex">
              {link?.ctaCopy && (
                <CtaButton
                  {...ctaProps}
                  copySize="bodyRegular"
                  variant="tertiaryForest"
                  onClick={triggerAnalytics}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </a>
  );
};

export default IllustrationCard;
